import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';
import { useQuery } from '@apollo/client';
import { CSVLink } from 'react-csv-enclosing-fix';  //fixes bug in react-csv
import { ALL_REPORTS, ALL_REPORTS_FOR_DATE } from './queries';
import useFilterData from './useFilterData';
import downloadJson from './downloadJson';

function ListingResults(props) {
	const { updateListEntryStatus, updateListResultsStatus, listEntryData, headers, saveLastDate } = props;
    const { coopid, obsdate, weekChecked } = listEntryData;
    const [ reportsData, setReportsData ] = useState([]);
    const [ rawData, setRawData ] = useState();
    const compareDateType = obsdate instanceof Date ? 'obs' : 'creation';
    const crnt = new Date();
    
    const padStr = (val) => val.toString().padStart(2, "0");    //zero-pad a two-digit string representation of a number
    const crntDateUTCString = crnt.getUTCFullYear().toString().substr(2) + padStr(crnt.getUTCMonth()+1) + padStr(crnt.getUTCDate()) + padStr(crnt.getUTCHours()) + padStr(crnt.getUTCMinutes());
    const filename = 'snowsurvey_export_' + crntDateUTCString + '.csv';

    var wkfirst, wklast;
    if (obsdate instanceof Date) {
        wkfirst = weekChecked ? new Date(obsdate.getTime() - (obsdate.getDay() * 24 * 60 * 60 * 1000)) : obsdate;
        wklast = weekChecked ? new Date(obsdate.getTime() + ((6-obsdate.getDay()) * 24 * 60 * 60 * 1000)) : obsdate;
    } else {
        wkfirst = obsdate[0];
        wklast = obsdate[1]
    }

    const reportForString = wkfirst.getFullYear() + "-" + (wkfirst.getMonth()+1) + "-" + wkfirst.getDate() +
          (weekChecked ? " to " + wklast.getFullYear() + "-" + (wklast.getMonth()+1) + "-" + wklast.getDate() : "");
    const caption =  (coopid === "*" ? "All" : coopid) + " reports " + (obsdate instanceof Date ? "for" : "created") + " " + reportForString;

    // filter out desired reports and store them in ReportsData
    useFilterData(rawData, coopid, wkfirst, wklast, saveLastDate, setReportsData, compareDateType);

    // fetch all reports
	const { loading, error } = useQuery(weekChecked ? ALL_REPORTS : ALL_REPORTS_FOR_DATE, { 
        variables: weekChecked ? {} : { year:obsdate.getFullYear().toString(), month:(obsdate.getMonth()+1).toString(), day:obsdate.getDate().toString() },  //not used for ALL_REPORTS
		fetchPolicy: "network-only",
        onCompleted: (data) => setRawData(weekChecked ? data.allReports.data : data.allReportsForDate.data)
	});
    if (loading) return 'Loading...';
    if (error) {
        alert('Error reading existing data - ' + (error.graphQLErrors.length && error.graphQLErrors[0].message) ? error.graphQLErrors[0].message : "GraphQL error");
    };
    
	const handleClick = () => {	
        updateListResultsStatus(false);
		updateListEntryStatus(true);
	};

    const handleDownJsonClick = () => {
		downloadJson(reportsData, "SSx-22_sweq.json");
	};

	return (
		<>
            {reportsData &&
                <>
                    <Typography variant="subtitle2" gutterBottom>
                        {caption}
                    </Typography>

                    {headers.map((head, j) => (
                        <Typography key={head.key} display="inline">
                            {j!==0?",":""}{head.label}
                        </Typography>
                    ))}
                    <br />

                    {reportsData.map((value, i) => (
                        <React.Fragment key={i}>
                            {headers.map((head, j) => (
                                <Typography key={i+head.key} display="inline">
                                    {j!==0?",":""}{value[head.key]}
                                </Typography>
                            ))}
                            <br />
                        </React.Fragment>
                    ))}

                    <Button variant="contained" color="primary" onClick={handleClick}>
                        Return
                    </Button>
                    <Button variant="contained"  color="primary" onClick={handleDownJsonClick}>
                        Export to JSON file
                    </Button>
                    <CSVLink data={reportsData} headers={headers} filename={filename} enclosingCharacter={``}>Export to CSV file</CSVLink>
                </>
            }
		</>
	);
};
export default ListingResults;